import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import { format } from "date-fns";
import { config, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { Modal } from "react-bootstrap";

const LeadDetail = () => {
  const { id_lead } = useParams();
  const [lead, setLead] = useState(null);
  const [opportunity, setOpportunity] = useState(null);
  const [users, setUsers] = useState(null);
  const [user, setUser] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [showDisqualify, setShowDisqualify] = useState(false);
  const [showTransfer, setShowTransfer] = useState(false);

  const navigate = useNavigate();

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    getLead();
  }, []);

  useEffect(() => {
    if (lead) {
      getOpportunity();
      getUsers();
    }
  }, [lead]);

  const getLead = async () => {
    try {
      const requestGetLead = {
        "id_lead": id_lead
      }
      const fetchGetLead = await jwtFetch(config.ENDPOINT + 'get/lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetLead)
      });
      const responseGetLead = await fetchGetLead.json();
      if (responseGetLead.status === 200) {
        let label = responseGetLead.data[0].lead_status;
        if (label === 'Marketing Qualified Lead') {
          label = responseGetLead.data[0].company_name && responseGetLead.data[0].bant_budget && responseGetLead.data[0].bant_authority && responseGetLead.data[0].bant_need && responseGetLead.data[0].bant_timeline && responseGetLead.data[0].source_name && responseGetLead.data[0].assigned_to ? 'Ready to Send' : 'Qualifying';
        } else if (label === 'Sent to Sales') {
          label = 'MQL';
        } else if (label === 'Qualifying') {
          label = responseGetLead.data[0].opportunity_code ? 'SQL' : 'Qualifying';
        }
        responseGetLead.data[0].label = label;
        if (responseGetLead.data[0].website_form) {
          const websiteForm = JSON.parse(responseGetLead.data[0].website_form);
          responseGetLead.data[0].website_form = websiteForm;
        }
        setLead(responseGetLead.data[0]);
        if (responseGetLead.data[0].assigned_to) {
          setUser({
            value: responseGetLead.data[0].assigned_to,
            label: responseGetLead.data[0].sales_name
          });
        }
      } else {
        alert(responseGetLead.message);
      }
    } catch (error) {
      console.error('Error in getLead:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getOpportunity = async () => {
    try {
      const requestGetOpportunity = {
        "lead_id": id_lead
      }
      const fetchGetOpportunity = await jwtFetch(config.ENDPOINT + 'get/opportunity', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetOpportunity)
      });
      const responseGetOpportunity = await fetchGetOpportunity.json();
      if (responseGetOpportunity.status === 200) {
        setOpportunity(responseGetOpportunity.data[0]);
      } else {
        alert(responseGetOpportunity.message);
      }
    } catch (error) {
      console.error('Error in getOpportunity:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getUsers = async () => {
    try {
      const requestGetUsers = {
        "user_department": 'Sales',
        "user_level": 'User',
      }
      const fetchGetUsers = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestGetUsers)
      });
      const responseGetUsers = await fetchGetUsers.json();
      if (responseGetUsers.status === 200) {
        const usersOptions = responseGetUsers.data.map((user) => ({
          value: user.user_keyid,
          label: user.full_name
        }));
        setUsers(usersOptions);
      } else {
        alert(responseGetUsers.message);
      }
    } catch (error) {
      console.error('Error in getUsers:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const editStatus = async (status, leadRemarks) => {
    try {
      setIsLoadingSubmit(true);
      const requestBody = {
        id_lead: id_lead,
        lead_status: status,
        updated_by: crmUser.user_keyid,
      };
      if (leadRemarks && leadRemarks.trim() !== '') {
        requestBody.lead_remarks = leadRemarks.trim();
      }
      const fetchEditLead = await jwtFetch(config.ENDPOINT + 'update/lead_status', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody)
      });
      const responseEditLead = await fetchEditLead.json();
      if (responseEditLead.status === 200) {
        window.location.reload();
      } else {
        alert(responseEditLead.message || 'Failed to update lead status');
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in editStatus:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  };

  const assignLead = async (isTransferMode = false) => {
    try {
      setIsLoadingSubmit(true);
      const fetchAssignLead = await jwtFetch(config.ENDPOINT + 'assign/lead', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_lead: id_lead,
          assigned_to: assignedTo ? assignedTo : lead.assigned_to,
          lead_status: 'Sent to Sales',
          lead_remarks: remarks ? remarks.trim() : lead.lead_remarks,
          is_transfer_mode: isTransferMode,
          updated_by: crmUser.user_keyid,
        })
      });
      const responseAssignLead = await fetchAssignLead.json();
      if (responseAssignLead.status === 200) {
        window.location.reload();
      } else {
        alert(responseAssignLead.message || 'Failed to send lead to Sales');
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in assignLead:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div id="lead-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="lead" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                {lead ? (
                  <section className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Lead Detail</div>
                        {lead.label === 'New' && (<span className="badge badge-sm ms-3 text-bg-secondary">New</span>)}
                        {lead.label === 'Qualifying' && (<span className="badge badge-sm ms-3 text-bg-warning">Qualifying</span>)}
                        {lead.label === 'MQL' && (<span className="badge badge-sm ms-3 text-bg-secondary">MQL</span>)}
                        {lead.label === 'Ready to Send' && (<span className="badge badge-sm ms-3 text-bg-success">Ready to Send</span>)}
                        {lead.label === 'Sent to Sales' && (<span className="badge badge-sm ms-3 text-bg-info">Sent to Sales</span>)}
                        {lead.label === 'SQL' && (<span className="badge badge-sm ms-3 text-bg-success">SQL</span>)}
                        {lead.label === 'Nurture' && (<span className="badge badge-sm ms-3 text-bg-warning">Nurture</span>)}
                        {lead.label === 'Disqualified' && (<span className="badge badge-sm ms-3 text-bg-danger">Disqualified</span>)}
                      </div>
                      {crmUser.user_level !== 'View' && (
                        <>
                          {lead.lead_status == 'New' && (
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <button className="btn btn-sm btn-outline-warning" onClick={() => editStatus('Nurture')} disabled={isLoadingSubmit}><i className="bi bi-reply me-1" /> Nurture</button>
                              <button className="btn btn-sm btn-outline-danger" onClick={() => editStatus('Disqualified')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-1" /> Disqualify</button>
                              <button className="btn btn-sm btn-outline-success" onClick={() => editStatus('Marketing Qualified Lead')} disabled={isLoadingSubmit}><i className="bi bi-check me-1" /> Qualify</button>
                            </div>
                          )}
                          {lead.lead_status == 'Marketing Qualified Lead' && (
                            (lead.company_name && lead.bant_budget && lead.bant_authority && lead.bant_need && lead.bant_timeline && lead.source_name && lead.assigned_to) ? (
                              <div className="d-flex align-items-center justify-content-between gap-2">
                                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/lead/edit/' + id_lead}><i className="bi bi-pencil me-1" /> Edit</button>
                                <button className="btn btn-sm btn-outline-warning" onClick={() => editStatus('Nurture')} disabled={isLoadingSubmit}><i className="bi bi-reply me-1" /> Nurture</button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => editStatus('Disqualified')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-1" /> Disqualify</button>
                                <button className="btn btn-sm btn-outline-info" onClick={() => assignLead()} disabled={isLoadingSubmit}><i className="bi bi-send me-1" /> Send to Sales</button>
                              </div>
                            ) : (
                              <div className="d-flex align-items-center justify-content-between gap-2">
                                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/lead/edit/' + id_lead}><i className="bi bi-pencil me-1" /> Complete Form</button>
                                <button className="btn btn-sm btn-outline-warning" onClick={() => editStatus('Nurture')} disabled={isLoadingSubmit}><i className="bi bi-reply me-1" /> Nurture</button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => editStatus('Disqualified')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-1" /> Disqualify</button>
                              </div>
                            )
                          )}
                          {lead.lead_status === 'Sent to Sales' && (
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <button className="btn btn-sm btn-outline-danger" onClick={() => setShowDisqualify(true)} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-1" /> Disqualify</button>
                              <button className="btn btn-sm btn-outline-success" onClick={() => editStatus('Qualifying')} disabled={isLoadingSubmit}><i className="bi bi-check me-1" /> Qualify</button>
                              <button className="btn btn-sm btn-outline-info" onClick={() => setShowTransfer(true)} disabled={isLoadingSubmit}><i className="bi bi-arrow-left-right me-1" /> Transfer</button>
                            </div>
                          )}
                          {lead.lead_status === 'Qualifying' && !lead.opportunity_code && (
                            (lead.company_name && lead.bant_budget && lead.bant_authority && lead.bant_need && lead.bant_timeline && lead.source_name && lead.assigned_to) ? (
                              <div className="d-flex align-items-center justify-content-between gap-2">
                                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/lead/edit/' + id_lead}><i className="bi bi-pencil me-1" /> Edit</button>
                                <button className="btn btn-sm btn-outline-warning" onClick={() => editStatus('Nurture')} disabled={isLoadingSubmit}><i className="bi bi-reply me-1" /> Nurture</button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => editStatus('Disqualified')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-1" /> Disqualify</button>
                                {crmUser.user_level === 'Admin' && (
                                  <button className="btn btn-sm btn-outline-info" onClick={() => setShowTransfer(true)} disabled={isLoadingSubmit}><i className="bi bi-arrow-left-right me-1" /> Transfer</button>
                                )}
                                <button className="btn btn-sm btn-success" type="button" onClick={() => window.location.href = '/lead/opportunity/' + id_lead}><i className="bi bi-plus-lg me-1" /> Create Opportunity</button>
                              </div>
                            ) : (
                              <div className="d-flex align-items-center justify-content-between gap-2">
                                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/lead/edit/' + id_lead}><i className="bi bi-pencil me-1" /> Complete Form</button>
                                <button className="btn btn-sm btn-outline-warning" onClick={() => editStatus('Nurture')} disabled={isLoadingSubmit}><i className="bi bi-reply me-1" /> Nurture</button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => editStatus('Disqualified')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-1" /> Disqualify</button>
                                {crmUser.user_level === 'Admin' && (
                                  <button className="btn btn-sm btn-outline-info" onClick={() => setShowTransfer(true)} disabled={isLoadingSubmit}><i className="bi bi-arrow-left-right me-1" /> Transfer</button>
                                )}
                              </div>
                            )
                          )}
                          {lead.lead_status == 'Nurture' && (
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <button className="btn btn-sm btn-outline-danger" onClick={() => editStatus('Disqualified')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-1" /> Disqualify</button>
                              {/* Marketing re-qualifies back into its own MQL stage; everyone else back into Sales' Qualifying stage. */}
                              <button className="btn btn-sm btn-outline-success" onClick={() => editStatus(crmUser.user_department === 'Marketing' ? 'Marketing Qualified Lead' : 'Qualifying')} disabled={isLoadingSubmit}><i className="bi bi-check me-1" /> Qualify</button>
                            </div>
                          )}
                        </>)}
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Number</div>
                          <div className="col-md-8">{lead.lead_code}</div>
                        </div>
                        {lead.company_name && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Company Group</div>
                            <div className="col-md-8">{lead.company_name} <a href={"/client/detail/" + lead.company_id}><i className="bi bi-link-45deg" /></a></div>
                          </div>
                        )}
                        {lead.subcompany_name && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Subsidiary</div>
                            <div className="col-md-8">{lead.subcompany_name} <a href={"/client/subsidiary/detail/" + lead.subcompany_id}><i className="bi bi-link-45deg" /></a></div>
                          </div>
                        )}
                        {lead.lead_category && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Category</div>
                            <div className="col-md-8">{lead.lead_category}</div>
                          </div>
                        )}
                        {lead.lead_products && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Product</div>
                            <div className="col-md-8">{lead.lead_products}</div>
                          </div>
                        )}
                        {lead.lead_registration && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Deal Registration Number</div>
                            <div className="col-md-8">{lead.lead_registration}</div>
                          </div>
                        )}
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Source</div>
                          <div className="col-md-8">{lead.source_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Channel</div>
                          <div className="col-md-8">{lead.source_channel}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Follow Up</div>
                          <div className="col-md-8">{lead.source_status}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Created Date</div>
                          <div className="col-md-8">{format(new Date(lead.created_on), 'd MMM yyyy')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Marketing Person</div>
                          <div className="col-md-8">{lead.marketing_name.replace('Luqman', 'System')}</div>
                        </div>
                        {lead.assigned_to && (
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Sales Person</div>
                            <div className="col-md-8">{lead.sales_name}</div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        {opportunity && (
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fs-14 mb-0"><strong>Opportunity</strong></p>
                                <a href={"/opportunity/detail/" + opportunity.id_opportunity}>{opportunity.opportunity_code} <i className="bi bi-link-45deg ms-1" /></a>
                              </div>
                            </div>
                          </div>
                        )}
                        {lead.contact_person_id ? (
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="fs-14 mb-0"><strong>Contact Person</strong></p>
                              </div>
                              <div className="p-2">
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Name</div>
                                  <div className="col-md-8">{lead.contact_name}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Email</div>
                                  <div className="col-md-8">{lead.contact_email}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Phone</div>
                                  <div className="col-md-8">{lead.contact_phone}</div>
                                </div>
                                <div className="row">
                                  <div className="col-md-4 text-secondary">Position</div>
                                  <div className="col-md-8">{lead.contact_position}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="fs-14 mb-0"><strong>Enquiry Form</strong></p>
                              </div>
                              <div className="p-2">
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Company</div>
                                  <div className="col-md-8">{lead.website_form.company_name}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Contact</div>
                                  <div className="col-md-8">{lead.website_form.contact_name}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Email</div>
                                  <div className="col-md-8">{lead.website_form.contact_email}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Phone</div>
                                  <div className="col-md-8">{lead.website_form.contact_phone}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Page Title</div>
                                  <div className="col-md-8">{lead.website_form.source_title}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-4 text-secondary">Page URL</div>
                                  <div className="col-md-8">{lead.website_form.source_url}</div>
                                </div>
                                {lead.website_form.source_referrer && (
                                  <div className="row">
                                    <div className="col-md-4 text-secondary">Referrer URL</div>
                                    <div className="col-md-8">{lead.website_form.source_referrer}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </section>
                ) : (
                  <p>No data</p>
                )}

                {lead && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Enquiry & BANT</strong></p>
                        </div>
                        <div className="p-2">
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Message</div>
                            <div className="col-md-10">{lead.lead_enquiry}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Budget</div>
                            <div className="col-md-10">{priceFormat(lead.bant_budget, 'IDR')}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Authority</div>
                            <div className="col-md-10">{lead.bant_authority}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Need</div>
                            <div className="col-md-10">{lead.bant_need}</div>
                          </div>
                          <div className="row">
                            <div className="col-md-2 text-secondary">Timeline</div>
                            <div className="col-md-10">{lead.bant_timeline}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {lead && lead.attachment_files && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Attachments</strong></p>
                        </div>
                        <div className="p-2">
                          {
                            JSON.parse(lead.attachment_files).map((file, index) => (
                              <div key={index} className="row mb-2">
                                <div className="col-md-2 text-secondary">File {index + 1}</div>
                                {console.log(file)}
                                <div className="col-md-10"><a href={file.files[0].fileUrl} target="_blank" rel="noopener noreferrer">{file.files[0].fileUrl} <i className="bi bi-link-45deg ms-2"></i></a></div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {lead && (
                  <section className="mb-4">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="fs-14 mb-0"><strong>Remarks</strong></p>
                        </div>
                        <div className="p-2">
                          <div className="row mb-2">
                            <div className="col-md-2 text-secondary">Marketing</div>
                            <div className="col-md-10">{lead.source_remarks}</div>
                          </div>
                          <div className="row">
                            <div className="col-md-2 text-secondary">Sales</div>
                            <div className="col-md-10">{lead.lead_remarks}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                <Modal show={showDisqualify} onHide={() => setShowDisqualify(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>Disqualify Lead</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row align-items-baseline form-group mb-2">
                      <div className="col-md-4">
                        <label>Remarks <span className="text-danger">*</span></label>
                      </div>
                      <div className="col-md-8">
                        <textarea className="form-control" rows="4" value={remarks} onChange={(e) => setRemarks(e.target.value)} required />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button className="btn btn-link" type="button" onClick={() => setShowDisqualify(false)}>Cancel</button>
                      <button
                        className="btn btn-danger"
                        type="button"
                        onClick={() => {
                          if (!remarks || remarks.trim() === '') return;
                          editStatus('Disqualified', remarks);
                        }}
                        disabled={!remarks || remarks.trim() === '' || isLoadingSubmit}
                      >
                        Disqualify
                      </button>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal show={showTransfer} onHide={() => setShowTransfer(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>Transfer Lead</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row align-items-baseline form-group mb-2">
                      <div className="col-md-4">
                        <label>Assign To <span className="text-danger">*</span></label>
                      </div>
                      <div className="col-md-8">
                        <select className="form-select" value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)} required>
                          <option value="">Select User</option>
                          {users && users.map(user => (
                            <option key={user.value} value={user.value}>{user.label}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="row align-items-baseline form-group mb-2">
                      <div className="col-md-4">
                        <label>Remarks <span className="text-danger">*</span></label>
                      </div>
                      <div className="col-md-8">
                        <textarea className="form-control" rows="4" value={remarks} onChange={(e) => setRemarks(e.target.value)} required />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button className="btn btn-link" type="button" onClick={() => setShowTransfer(false)}>Cancel</button>
                      <button className="btn btn-info" type="button" onClick={() => {
                        if (!remarks || remarks.trim() === '') return;
                        if (!assignedTo || assignedTo.trim() === '') return;
                        assignLead(true);
                      }}
                        disabled={!remarks || remarks.trim() === '' || isLoadingSubmit}
                      >Transfer</button>
                    </div>
                  </Modal.Body>
                </Modal>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadDetail;


